import { FC } from "react";
import { AirplaneIcon } from "src/assets/Icons";
import { RowSeat, SeatType } from "src/Modules/Flights/constants/JourneyDetails";
import ColumnHeader from "../components/ColumnHeader/ColumnHeader";
import RowSeating from "../components/RowSeating/RowSeating";
import planeNose from "../assets/planenose.png";
import planetail from "../assets/planetail.svg";
interface PlaneSeatingCommonProps {
  colMap: Map<number, string>;
  rows: RowSeat[] | undefined;
  craftType: string | undefined;
  reservedSeats: Set<string>;
  onClick: (val: SeatType) => void;
  flightId: string | number | undefined;
}

const PlaneSeatingCommon: FC<PlaneSeatingCommonProps> = ({ colMap, rows, craftType, reservedSeats, onClick, flightId }) => {
  const cols = Array.from(colMap.entries());
  return (
    <div className="font-poppins md:bg-background-minimal md:p-6">
      <div className="relative outline outline-border-default rounded-t-nose rounded-b-160! z-30 bg-background-default overflow-hidden bg-background-default  flex flex-col gap-5 overflow-hidden p-2 md:px-6 md:pt-8 md:pb-8 pt-16! pb-24!">
        <img src={planeNose} aria-hidden/>
        <div className="text-font-minimal flex w-full shrink-0 flex-col items-center justify-center text-sm md:gap-1 md:text-xs">
          <span className="bg-background-subtle hidden h-1 w-12 rounded-full md:block" />
          <AirplaneIcon className="h-5 w-5 md:h-4 md:w-4" transform="rotate(-90)" />
          <span>{craftType}</span>
        </div>
        <div className="[--seat-col-min:clamp(3rem,9vw,4rem)] md:[--seat-col-min:0px] scrollbar-hide flex w-full flex-1 flex-col items-center-safe gap-2 overflow-auto px-4 md:items-center md:justify-center md:gap-3 md:overflow-visible md:px-0">
          <ColumnHeader colMap={colMap} />

          {rows?.map((row: RowSeat, index: number) => (
            <RowSeating key={`${flightId}-${index}`} cols={cols} row={row} onClick={onClick} reservedSeats={reservedSeats} />
          ))}
        </div>
      </div>
      <img src={planetail} aria-hidden className="-mt-10!"/>
    </div>
  );
};

export default PlaneSeatingCommon;
